import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../log/log.service';
import { PaymentType } from '../../event/models/payment-type';

@Pipe({
  name: 'paymentType'
})
export class PaymentTypePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService,
    private logService: LogService) { }

  transform(value: any, args?: any): any {

    // Pipes need to handle nulls/undefined
    if (!value) {
      value = '';
    }

    value = value.toLowerCase().toString();

    let returnValue = '';

    switch (value) {
      case PaymentType.FINAL_PAYMENT:
      case PaymentType.INITIAL:
        returnValue = this.translateService.instant('PAYMENT_TYPE.FINAL_PAYMENT');
        break;
      case PaymentType.PREPAYMENT:
        returnValue = this.translateService.instant('PAYMENT_TYPE.PREPAYMENT');
        break;
      default:
        this.logService.info(this.translateService.instant('PAYMENT_TYPE.UNKNOWN', { key: value }));
    }

    return returnValue;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/payment-type.pipe.ts